import { useEffect } from "react";
import { useLocation } from "wouter";
import { FullPageLoader } from "@/components/shell/FullPageLoader";
import { useAuth } from "@/lib/auth/AuthContext";

/**
 * The identity provider's redirect target (FR-10).
 *
 * MSAL consumes the authorization code from this URL in `getMsalApp()`, which
 * calls `handleRedirectPromise` exactly once before anything reads accounts.
 * This page therefore only waits and then moves on — it must never rewrite the
 * URL, because doing so strips the fragment MSAL has not read yet and the app
 * bounces back to sign-in forever.
 */
export default function CallbackPage() {
  const { status } = useAuth();
  const [, navigate] = useLocation();

  useEffect(() => {
    if (status === "signed-in") navigate("/", { replace: true });
    if (status === "signed-out" || status === "failed") navigate("/sign-in", { replace: true });
  }, [status, navigate]);

  return <FullPageLoader message="Finishing sign-in…" main />;
}
